import { useEffect, useRef, useState, useCallback } from 'react';
import styles from './SupportPage.module.scss';
import cateoryStyles from '../components/categoryCard/CategoryCard.module.scss';
import SupportForm from './supportForm/SupportForm';
import SupportAccordion from './supportAccordion/SupportAccordion';
import {
  PRODUCT_QUESTION,
  ORDERING_MEMEBER,
} from '../../../../commons/Constants/FAQPage';
import CategoryCard from '../components/categoryCard/CategoryCard';
import ContactUsCard from '../components/contactUsCard/ContactUsCard';
import { Divider } from '../../../../commons/components/ui';
import SupportHeader from './supportHeader/SupportHeader';
import { CountryDropdown } from '../../../../commons/hoc';
import { PHONE_ICON } from '../../../../src/assets/images/icons';
import useMediaQuery from '@mui/material/useMediaQuery';

const SupportPage = () => {
  const [activeCategory, setActiveCategory] = useState('');
  const [supportDivUpdated, setSupportDivUpdated] = useState(false);
  const observer = useRef([]);
  const sideMenuRef = useRef([]);
  const accordianRef = useRef([]);
  const dropdownRef = useRef(null);
  const isTab = useMediaQuery('(max-width:983px)');

  useEffect(() => {
    const options = {
      threshold: 0.5,
    };
    observer.current = new IntersectionObserver((entries) => {
      const visibleSection = entries.find(
        (entry) => entry.isIntersecting
      )?.target;
      if (visibleSection) {
        sideMenuRef.current.forEach((section) => {
          if (visibleSection.id == section.getAttribute('id')) {
            section.classList.add(cateoryStyles['categoryNameActive']);
          } else {
            section.classList.remove(cateoryStyles['categoryNameActive']);
          }
        });
      }
      if (isTab && visibleSection?.id) {
        dropdownRef.current.value = visibleSection.id;
      }
    }, options);

    const sections = document.querySelectorAll('[data-section]');
    sections.forEach((section) => {
      observer.current.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.current.unobserve(section);
      });
    };
  }, [supportDivUpdated]);

  useEffect(() => {
    // Update the observer when the DOM changes
    const handleDOMChanges = (mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.matches('[data-section]')) {
              observer.current.observe(node);
              setSupportDivUpdated(!supportDivUpdated);
            }
          });

          mutation.removedNodes.forEach((node) => {
            if (node.nodeType === 1 && node.matches('[data-section]')) {
              observer.current.unobserve(node);
            }
          });
        }
      });
    };

    const observerConfig = {
      childList: true,
      subtree: true,
    };

    const domObserver = new MutationObserver(handleDOMChanges);
    domObserver.observe(document.body, observerConfig);

    return () => {
      domObserver.disconnect();
    };
  }, []);

  const refCallback = useCallback((element) => {
    if (element) {
      sideMenuRef.current.push(element);
    }
  }, []);

  const refAccordianCallback = useCallback((element) => {
    if (element) {
      accordianRef.current.push(element);
    }
  }, []);

  const categoryData = [
    {
      id: 'request',
      accordionTitle: 'Open a Support Request',
      ref: refCallback,
    },
    {
      id: 'faq',
      accordionTitle: 'FAQ',
      subcategories: [
        {
          id: 'product',
          accordionTitle: 'Product',
          ref: refCallback,
        },
        {
          id: 'ordering',
          accordionTitle: 'Ordering & Membership',
          ref: refCallback,
        },
      ],
    },
  ];

  const accordionData = [
    {
      id: 'request',
      accordionTitle: 'Open a Support Request',
      accordionItems: PRODUCT_QUESTION,
    },
    {
      id: 'product',
      accordionTitle: 'Product',
      accordionItems: PRODUCT_QUESTION,
    },
    {
      id: 'ordering',
      accordionTitle: 'Ordering & Membership',
      accordionItems: ORDERING_MEMEBER,
    },
  ];
  const scrollIntoViewWithOffset = (selector, offset) => {
    window.scrollTo({
      behavior: 'smooth',
      top:
        selector.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    });
  };
  const categoryChange = (category) => {
    sideMenuRef.current.forEach((section) => {
      if (category == section.getAttribute('id')) {
        section.classList.add(cateoryStyles['categoryNameActive']);
      } else {
        section.classList.remove(cateoryStyles['categoryNameActive']);
      }
    });
    accordianRef.current.forEach((section) => {
      if (category == section.getAttribute('id')) {
        if (!isTab) {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else {
          scrollIntoViewWithOffset(section, 90);
        }
      }
    });
  };

  const Accordion = ({ refAccordianCallback }) => {
    return accordionData
      .filter((accData) => accData.id !== 'request')
      .map((accData) => (
        <div
          id={`${accData.id}`}
          className={styles.supportAccordionContainer}
          data-section
          ref={refAccordianCallback}
        >
          <SupportAccordion
            accordionTitle={accData.accordionTitle}
            accordionItems={accData.accordionItems}
          />
        </div>
      ));
  };

  const contactMenu = {
    contactNumber: '833-888-1533',
    icon: <PHONE_ICON />,
    link: 'tel:+1-833-888-1533',
  };

  return (
    <>
      <SupportHeader />
      <div className={styles.supportPageExtender}>
        <div className={styles.supportPageMainContainer}>
          <div className={styles.supportPageContainer}>
            <div
              className={styles.supportPageContainerLeft}
              id="support-container"
            >
              <div className={styles.categoryContainer}>
                <div className={styles.categoryDropdownContainer}>
                  <div className={styles.categoryDropdownFieldContainer}>
                    <CountryDropdown
                      options={accordionData.map((category) => ({
                        value: category.id,
                        label: category.accordionTitle,
                      }))}
                      tkey="label"
                      onChange={(e) => categoryChange(e.target.value)}
                      ref={dropdownRef}
                    />
                  </div>
                </div>
              </div>
              <Divider className={styles.dividerContainer} />
              <div className={styles.contactUsCardContainer}>
                <ContactUsCard contactCardData={contactMenu} />
              </div>
              <div className={styles.supportCategoryContainer}>
                <div className={styles.supportFormContainer}>
                  <SupportForm refAccordianCallback={refAccordianCallback} />
                  <div className={styles.divider}></div>
                </div>
              </div>
              <Accordion refAccordianCallback={refAccordianCallback} />
            </div>
            <div>
              <div className={styles.categoryCardContainer}>
                <div className={styles.categoryCardContainer}>
                  <CategoryCard
                    categoryData={categoryData}
                    activeCategory={activeCategory}
                    categoryChange={categoryChange}
                    categoryCardData={contactMenu}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportPage;
